export const isDiscordHost = (): boolean => {
  if (typeof window === 'undefined') return false;
  return window.location.hostname.endsWith('discordsays.com');
};

export const forceDiscordNet = (): boolean => {
  if (typeof window === 'undefined') return false;
  return new URLSearchParams(window.location.search).has('forceDiscordNetworking');
};

export function apiUrl(endpoint: string): string {
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  if (isDiscordHost() || forceDiscordNet()) {
    // No Discord, utiliza sempre a mesma origem proxied pelo URL Mapping
    return cleanEndpoint;
  }
  // No navegador autônomo / testes, aponta para o worker de sinalização caso esteja em localhost
  if (typeof window !== 'undefined' && window.location.hostname === 'localhost') {
    return `https://nexia-live-signaling.nexia-app.workers.dev${cleanEndpoint}`;
  }
  return cleanEndpoint;
}

export function getSignalingUrl(): string {
  if (isDiscordHost() || forceDiscordNet()) {
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${protocol}//${window.location.host}/ws`;
  }
  const envUrl = import.meta.env.VITE_SIGNALING_URL;
  if (envUrl && (envUrl.startsWith('ws://') || envUrl.startsWith('wss://'))) return envUrl;
  const protocol = typeof window !== 'undefined' && window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  const host = typeof window !== 'undefined' ? window.location.host : 'localhost';
  return `${protocol}//${host}${envUrl || '/ws'}`;
}
